module.exports = __webpack_public_path__ + "static/media/that-really-bugs-me.6a7afc37.txt";